import { render, staticRenderFns } from "./FormFinishRegister.vue?vue&type=template&id=f74391b4&scoped=true"
import script from "./FormFinishRegister.vue?vue&type=script&lang=js"
export * from "./FormFinishRegister.vue?vue&type=script&lang=js"
import style0 from "./FormFinishRegister.vue?vue&type=style&index=0&id=f74391b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74391b4",
  null
  
)

export default component.exports